import { render, staticRenderFns } from "./DictImportModal.vue?vue&type=template&id=5416a703&scoped=true"
import script from "./DictImportModal.vue?vue&type=script&lang=js"
export * from "./DictImportModal.vue?vue&type=script&lang=js"
import style0 from "./DictImportModal.vue?vue&type=style&index=0&id=5416a703&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416a703",
  null
  
)

export default component.exports